import { render, staticRenderFns } from "./SettingsPromoteStudents.vue?vue&type=template&id=112bb87f"
import script from "./SettingsPromoteStudents.vue?vue&type=script&lang=js"
export * from "./SettingsPromoteStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports